import { Sidebar } from "../../shared/components";
import { AuthGuard } from "../../shared/guards/AuthGuard";
import { PeopleListPresentation } from "./components/PeoplePresentation";

export const PeoplePage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<PeopleListPresentation />
			</Sidebar>
		</AuthGuard>
	);
};
